import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import Grid from "@material-ui/core/Grid";
import { ResponsiveLine } from "@nivo/line";
import "./index.scss";
import uniqBy from "lodash/unionBy";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { instance } from "Actions/AxiosInstance";
import Paper from "@material-ui/core/Paper";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import Add from "@material-ui/icons/Add";
import Input from "@material-ui/core/Input";
import deleteIcon from "Assets/Icons/Actions/cross-blue.svg";
import { getMonthName, getFormattedDate, convertDateForBackend } from "Utils";
import Tooltip from "@material-ui/core/Tooltip";
import { ErrorMessages } from "Constants";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import { Line } from "react-chartjs-2";
import DynamicForm from "Component/DynamicForm";
import moment from "moment";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
  popOverPaper: {
    width: 140,
    height: 176,
    background: "transparent",
  },
});

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsobjectiveid: this.props.detailsobjectiveid,
      detailsobjective: [],
      tempobjectivetask: [],
      objectivestatusbackup: [],
      right: true,
    };
    this.onSave = this.onSave.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.adddetailsTask = this.adddetailsTask.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.deleteTask = this.deleteTask.bind(this);
  }

  adddetailsTask() {
    const { tempobjectivetask } = this.state;
    const objTemp = {
      objectivetaskid: null,
      tasktitle1: null,
      description: null,
    };
    tempobjectivetask.push(objTemp);
    this.setState({
      tempobjectivetask,
    });
  }

  deleteTask(index) {
    const { tempobjectivetask } = this.state;
    tempobjectivetask.splice(index, 1);
    this.setState({
      tempobjectivetask,
    });
  }

  componentDidMount() {
    const { detailsobjectiveid } = this.props;
    this.props.removeSaveProgress();
    if (detailsobjectiveid) {
      this.viewDetails(detailsobjectiveid);
    }
  }

  handleChange1(key, value, optional = null) {
    const { detailsobjective, tempobjectivetask } = this.state;
    if (
      key === "objectivetask" &&
      detailsobjective[0].objectivetask[optional].taskstatusid != 4
    ) {
      detailsobjective[0].objectivetask[optional].taskstatusid = value;
      this.setState({
        detailsobjective,
      });
    } else if (key == "tempobjectivetask") {
      tempobjectivetask[optional].tasktitle = value;
      this.setState({
        tempobjectivetask,
      });
    }
  }

  onSave() {
    const data = {
      taskupdate:
        this.state.detailsobjective &&
        this.state.detailsobjective[0].objectivetask &&
        this.state.detailsobjective[0].objectivetask.filter(
          (x) => x.taskstatusid && x.taskstatusid == true,
        ),
    };
    if (
      data &&
      data.taskupdate &&
      data.taskupdate.length == 0 &&
      this.state.tempobjectivetask.length == 0
    ) {
      this.props.enqueueSnackbar("Please select task or add task", {
        variant: "error",
      });
    } else if (
      this.state.tempobjectivetask[0] &&
      this.state.tempobjectivetask[0].tasktitle == null
    ) {
      this.props.enqueueSnackbar("Please add task", {
        variant: "error",
      });
    } else if (data.taskupdate && data.taskupdate.length != 0) {
      this.props.enqueueSnackbar(
        `Are you sure you have completed these  ${data.taskupdate.length}  tasks ?`,
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                data.taskupdate.map((x) => {
                  if (x.taskstatusid == true) {
                    x.taskstatusid = 4;
                    x.objectiveid = this.state.detailsobjective[0].objectiveid;
                  }
                });
                this.props.closeSnackbar();
                instance.post("perform/taskupdate", data).then(
                  () => {
                    this.onAdd();
                    this.props.enqueueSnackbar(ErrorMessages.E0000, {
                      variant: "success",
                    });
                    this.setState(
                      {
                        right: false,
                      },
                      this.props.toggleDrawer("right", false),
                    );
                  },
                  (error) => {
                    const CommonError = error.response
                      ? error.response.data.error.message
                      : error.message;
                    this.props.enqueueSnackbar(CommonError, {
                      variant: "error",
                    });
                  },
                );
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    } else {
      this.onAdd();
    }
  }

  viewDetails(objectiveid) {
    instance.get(`perform/getobjectivedetails/${objectiveid}`).then((resp) => {
      this.setState({
        detailsobjective: resp.data.result,
        isViewDetails: true,
        right: true,
        isActivity: false,
        isCreateObjective: false,
        editobjective: false,
        postPone: false,
        isKeyResult: false,
        updateProgress: false,
      });
    });
  }

  onAdd() {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const data = {
      task: this.state.tempobjectivetask.filter((x) => x.tasktitle != null),
      objectiveid:
        this.state.detailsobjective[0] &&
        this.state.detailsobjective[0].objectiveid,
    };
    if (!issaveinprogress && data.task.length != 0) {
      this.props.setSaveProgress(true);
      instance
        .post("perform/createtask", data)
        .then(() => {
          this.props.removeSaveProgress();
          this.setState(
            {
              right: false,
              // isobjectivedropdown: false,
              tempobjectivetask: [],
            },
            () => this.viewDetails(data.objectiveid),
          );
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const { detailsobjective, tempobjectivetask } = this.state;
    const { classes } = this.props;

    let x = [];
    let linedata = [];
    if (
      detailsobjective[0] &&
      detailsobjective[0].progress[0] &&
      detailsobjective[0].progress[0].log[0]
    ) {
      const temp = [];
      detailsobjective[0].progress[0].log.forEach((log) => {
        const index = temp.findIndex(
          (t) =>
            moment(t.lastprogessupdate, "YYYY-MM-DD HH:mm:ss").format(
              "MM-DD",
            ) ==
            moment(log.lastprogessupdate, "YYYY-MM-DD HH:mm:ss").format(
              "MM-DD",
            ),
        );
        if (index != -1) {
          temp[index] =
            log.lastprogessupdate > temp[index].lastprogessupdate
              ? log
              : temp[index];
        } else {
          temp.push(log);
        }
      });
      x = temp.map((log) => ({
        value: convertDateForBackend(log.lastprogessupdate),
        y: log.achievetargetvalue,
      }));
      const now =
        parseInt(
          moment
            .duration(
              moment(x[x.length - 1].value, "YYYY-MM-DD").diff(
                moment(x[0].value, "YYYY-MM-DD").startOf("month"),
              ),
            )
            .asDays(),
        ) + 1;
      let livedate = moment(x[0].value, "YYYY-MM-DD")
        .startOf("month")
        .format("YYYY-MM-DD");
      const arr = [];
      [...Array(now)].forEach(() => {
        arr.push(livedate);
        livedate = moment(livedate, "YYYY-MM-DD")
          .add(1, "days")
          .format("YYYY-MM-DD");
      });
      let defaultvalue = 0;
      linedata = arr.map((date) => {
        let obj = null;
        if (x.find((d) => d.value == date)) {
          defaultvalue = x.find((d) => d.value == date).y;
          obj = {
            x: date,
            y: defaultvalue,
          };
          return obj;
        }
        obj = {
          x: date,
          y: defaultvalue,
        };
        return obj;
      });
    }
    console.log("linedata: ", linedata);
    return (
      <div
        className="thin-scroll"
        style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
      >
        <div className="margin-bottom-16">
          <Grid container className="margin-top-8">
            {detailsobjective &&
              detailsobjective.length !== 0 &&
              detailsobjective.map((x) => (
                <Grid item xs={12} md={12} sm={12}>
                  <p className="normal-dark-secondary">{x.objectivetitle}</p>
                  <Paper className="chart-outer margin-bottom-16 margin-top-16 rounded-rectangle-paper">
                    <div
                      style={{
                        // width: "100%",
                        // height: "60px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                        flexDirection: "row",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          borderRight: "1px solid #d8d8d8",
                          paddingRight: 32,
                          marginTop: 8,
                        }}
                      >
                        <p> Achieved </p>
                        <p className="margin-top-2">
                          {" "}
                          {(x.progress[0] &&
                            (x.measuretypeid != 1
                              ? x.progress[0].achievetargetvalue
                              : x.progress[0].achievepercentage)) ||
                            0}{" "}
                        </p>
                      </div>

                      <div
                        className="padding-left-16"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: 8,
                        }}
                      >
                        <p> Target </p>
                        <p className="margin-top-2">{x && x.targetvalue}</p>
                      </div>
                    </div>
                    <div className="radar-outer" style={{ height: 300 }}>
                      <ResponsiveLine
                        data={[
                          {
                            id: "Period",
                            data: linedata,
                          },
                        ]}
                        margin={{
                          top: 64,
                          right: 50,
                          bottom: 50,
                          left: 64,
                        }}
                        yScale={{
                          type: "linear",
                          stacked: false,
                        }}
                        xScale={{
                          type: "time",
                          format: "%Y-%m-%d",
                          precision: "day",
                        }}
                        xFormat="time:%Y-%m-%d"
                        axisLeft={{
                          legend: "%",
                          legendPosition: "middle",
                          legendOffset: -56,
                        }}
                        axisBottom={{
                          format: "%b %d",
                          tickValues: "every 1 month",
                          legend: "Period",
                          legendPosition: "middle",
                          legendOffset: 36,
                        }}
                        legends={[
                          {
                            anchor: "bottom",
                            direction: "column",
                            justify: false,
                            translateX: 17,
                            translateY: 160,
                            itemsSpacing: 0,
                            itemDirection: "left-to-right",
                            itemWidth: 80,
                            itemHeight: 20,
                            itemOpacity: 0.75,
                            symbolSize: 12,
                            symbolShape: "circle",
                            symbolBorderColor: "rgba(0, 0, 0, .5)",
                            effects: [
                              {
                                on: "hover",
                                style: {
                                  itemBackground: "rgba(0, 0, 0, .03)",
                                  itemOpacity: 1,
                                },
                              },
                            ],
                          },
                        ]}
                        colors={"#98ffda"}
                        pointSize={2}
                        pointColor={{ theme: "background" }}
                        pointBorderWidth={2}
                        pointBorderColor={{ from: "serieColor" }}
                        pointLabel="y"
                        pointLabelYOffset={-12}
                        useMesh={true}
                        animate={true}
                      />
                    </div>
                  </Paper>
                  <Grid container>
                    <Grid item xs={12} md={3} sm={12}>
                      <p className="small-dark-secondary t-bold margin-bottom-16">
                        Aligned to
                      </p>
                    </Grid>
                    <Grid item xs={12} md={9} sm={12}>
                      <p className="small-dark-secondary margin-bottom-16">
                        {x.alignobjectivename}
                      </p>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Owner
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            {x.employeename}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Last Updated
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            {getFormattedDate(x.updateddate)}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Type
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            {x.objectivetype}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Due on
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            {getFormattedDate(x.duedate)}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Status
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            {x.objectivestatus}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Period
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            Q{x.frequencytypeid} {x.year}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} sm={12}>
                      {/* <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Weightage
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <p className="small-dark-secondary margin-bottom-16">
                            {x.weightagetype}
                          </p>
                        </Grid>
                      </Grid> */}
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={3} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16">
                            Description
                          </p>
                        </Grid>
                        <Grid item xs={12} md={9} sm={12}>
                          <p
                            className="small-dark-secondary margin-bottom-16 floatleft width80  display-block"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {x.description}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Grid container>
                        <Grid item xs={12} md={3} sm={12}>
                          <p className="small-dark-secondary t-bold margin-bottom-16 ellipsis display-block">
                            Tasks
                          </p>
                        </Grid>
                        <Grid item xs={12} md={9} sm={12}>
                          {x &&
                            x.objectivetask &&
                            x.objectivetask.length != 0 &&
                            x.objectivetask.map((y, index) => (
                              <div>
                                <div style={{}}>
                                  <span style={{ float: "left" }}>
                                    <DynamicForm
                                      fields={checkboxinputconverter({
                                        value: y.taskstatusid,
                                        placeholder: "",
                                        // inputProps={{ "aria-label": "description" }},
                                        label: "",
                                      })}
                                      onChange={(value) => {
                                        this.handleChange1(
                                          "objectivetask",
                                          value,
                                          index,
                                        );
                                      }}
                                    />
                                  </span>
                                  <p
                                    className="normal-dark-secondary floatleft width80 ellipsis"
                                    style={
                                      y.taskstatusid
                                        ? {
                                            textDecoration: "line-through",
                                            marginLeft: 8,
                                          }
                                        : {
                                            marginLeft: 8,
                                          }
                                    }
                                  >
                                    {y.tasktitle}
                                  </p>
                                </div>
                                <div className="clear-float"></div>
                              </div>
                            ))}
                          {this.props.permissions &&
                            this.props.permissions.editable && (
                              <div>
                                {tempobjectivetask &&
                                  tempobjectivetask.length != 0 &&
                                  tempobjectivetask.map((temp, index) => (
                                    <div className="position-rel margin-bottom-10">
                                      <Input
                                        placeholder="add new task"
                                        inputProps={{
                                          "aria-label": "description",
                                        }}
                                        style={{ width: "90%" }}
                                        value={temp.tasktitle}
                                        isClearable={true}
                                        onChange={(event) => {
                                          this.handleChange1(
                                            "tempobjectivetask",
                                            event.target.value,
                                            index,
                                          );
                                        }}
                                      />
                                      <span
                                        onClick={() => this.deleteTask(index)}
                                        className="cursour-pointer action-btn"
                                        style={{
                                          position: "absolute",
                                          right: 0,
                                        }}
                                      >
                                        <img
                                          src={deleteIcon}
                                          className="vertical-middle"
                                        ></img>
                                      </span>
                                    </div>
                                  ))}
                                <div
                                  className="cursor-pointer clear-both"
                                  onClick={() => this.adddetailsTask()}
                                >
                                  <Add
                                    style={{
                                      height: 16,
                                      width: 16,

                                      marginRight: 8,
                                      position: "relative",
                                      top: 3,
                                      borderRadius: 16,
                                      background: "#1E8CED",
                                      color: "#fff",
                                    }}
                                  />
                                  <span
                                    style={{ color: "#1E8CED", fontSize: 14 }}
                                  >
                                    Add Task{" "}
                                  </span>
                                </div>
                                <div className="margin-top-24 margin-bottom-16">
                                  <Button
                                    variant="contained"
                                    className="btn btn-primary-md-blue"
                                    disabled={
                                      this.props.SaveInProgressReducer
                                        .issaveinprogress
                                    }
                                    onClick={() => {
                                      this.onSave();
                                    }}
                                  >
                                    SAVE
                                  </Button>
                                </div>
                              </div>
                            )}{" "}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Details)));
